import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios, publicAxios } from "../api";


export const fetchCompanyData = createAsyncThunk(
  "order/fetchCompanyData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await publicAxios.get(`/api/user/construction/company_data/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid code.");
      }

      return response.data.data;
    } catch (error) {
      console.error("Error fetching order:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch order"
      );
    }
  }
);


const initialState = {
  companyData: null,
  status: "idle",
  error: null,
};

const companyDataSlice = createSlice({
  name: "companyData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCompanyData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.companyData = action.payload;
      })
      .addCase(fetchCompanyData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default companyDataSlice.reducer;